import styled from 'styled-components'

export default styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.spacing24}px;

  .login-card {
    width: 100%;
    max-width: 500px;
  }
`

export const Logo = styled.img`
  width: 200px;
  display: block;
  margin: auto;
`
